import type { Field, FieldValue } from 'models/field';
import type { I18n } from 'utils/translations';

const translateViewOptionsLabel = (
  viewOptions: Field['viewOptions'],
  i18n: I18n,
): string | undefined => {
  return viewOptions?.label
    ? i18n.t(viewOptions.label as string)
    : (viewOptions?.label as string | undefined);
};

const translateViewOptionsSection = (
  i18n: I18n,
): string | undefined => {
  return i18n.t('academicFields.sectionName.text');
};

const translateFieldValues = (values: FieldValue, i18n: I18n): FieldValue => {
  const isArrayValues = Array.isArray(values);
  if (!isArrayValues) {
    return [values] as unknown as FieldValue;
  }

  return values.map(value => {
    if (value === null) {
      return value;
    }
    const isObject = typeof value === 'object';
    const hasLabel = isObject && 'label' in value;
    if (!hasLabel) {
      return value;
    }

    const isLabelNumeric = !isNaN(Number(value.label)) && value.label.trim() !== "";
    if (isLabelNumeric) {
      return value;
    }

    return {
      ...value,
      label: i18n.t(value.label),
    };
  }) as unknown as FieldValue;
};

export const translateFields = (fields: Field[], i18n: I18n): Field[] => {
  return fields.map(field => ({
    ...field,
    value: field.value
      ? translateFieldValues(field.value as FieldValue, i18n)
      : field.value,
    viewOptions: {
      ...field.viewOptions,
      label:
        (translateViewOptionsLabel(field.viewOptions, i18n) as string) ||
        (field.viewOptions?.label as string) ||
        '',
      sectionIdentifier:
        (field.viewOptions?.sectionIdentifier as FieldValue) || null,
      sectionName:
        (translateViewOptionsSection(i18n) as string) ||
        (field.viewOptions?.sectionName as FieldValue) ||
        '',
      sectionDescription:
        (field.viewOptions?.sectionDescription as FieldValue) || null,
    },
  }));
};
